/**
 * Store to the current session id and handle session refresh logic
 * @module
 */
var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var DateEnv = require('../env/date');
var uuid = require('optimizely-uuid');

// 30 minutes of inactivity before its a new session
var SESSION_INACTIVITY_DURATION = 30 * 60 * 1000;

module.exports = {
  initialize: function() {
    this.__state = {
      lastSessionTimestamp: 0,
      sessionId: null,
    };

    this.on(actionTypes.REFRESH_SESSION, this.__refreshSession);
    this.on(actionTypes.LOAD_SESSION_STATE, this.__loadSessionState);
  },

  /**
   * Returns the entire SessionStore state
   */
  getState: function() {
    return _.cloneDeep(this.__state);
  },

  /**
   * Returns the current sessionId
   * @return {UUID}
   */
  getSessionId: function(): string {
    return this.__state.sessionId;
  },

  /**
   * @param {SessionState} payload
   */
  __loadSessionState: function(payload:SessionState) {
    if (__INVARIANT__) {
      require('../utils/invariant').isType('SessionState', payload);
    }
    this.__state.sessionId = payload.sessionId;
    this.__state.lastSessionTimestamp = payload.lastSessionTimestamp;
    this.emitChange();
  },

  /**
   * Reset sessionId if it's not already set, or if the lastSessionTimestamp is sufficiently far in the past.
   */
  __refreshSession: function() {

    var now = DateEnv.now();
    var lastSessionTimestamp = this.__state.lastSessionTimestamp;

    if (!this.__state.sessionId || now - lastSessionTimestamp > SESSION_INACTIVITY_DURATION) {
      // should be a new session
      this.__state.sessionId = uuid.generate();
    }
    this.__state.lastSessionTimestamp = now;
    this.emitChange();
  },
};
